import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  systemSettings: {},
  selectedAddonLoginDetails: {},
  selectedPushNotificationDetails: {},
  organizationTopListingSubscriptionPlans:[]
};

const addonAndSponsorship = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_ALL_SYSTEM_SETTINGS: {
      draft.systemSettings = payload?.systemSettings;
      break;
    }
    case Actions.SELECTED_ADDON_LOGIN_DETAILS: {
      draft.selectedAddonLoginDetails = payload?.selectedAddonLoginDetails;
      break;
    }
    case Actions.SELECTED_PUSH_NOTIFICATION_DETAILS: {
      draft.selectedPushNotificationDetails = payload?.selectedPushNotificationDetails;
      break;
    }
    case Actions.GET_ORGANIZATION_TOP_LISTING_SUBSCRIPTION_PLAN_LIST: {
      draft.organizationTopListingSubscriptionPlans = payload?.organizationTopListingSubscriptionPlans && payload?.organizationTopListingSubscriptionPlans?.data?.map((element)=>{
        return {
          ...element,
          value:element?._id,
          label:element?.name
        }
      });
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default addonAndSponsorship;
